/**
 * DevRoleSwitcher — floating button to toggle between trainer/client in dev mode
 * Only renders when dev auth bypass is active.
 */
import useAuth from '../../auth/useAuth';

const DevRoleSwitcher = () => {
  const { role, isBeta, toggleDevRole } = useAuth();

  if (!toggleDevRole) return null;

  const label = isBeta ? 'beta' : role;

  return (
    <button className="dev-role-switcher" onClick={toggleDevRole}>
      DEV: {label}
    </button>
  );
};

export default DevRoleSwitcher;
